import React from "react";
import Icon from "./Icon";

export const BookmarksIcon = () => (
  <Icon>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M16.6663 15.0007L18.333 15.834V2.50065C18.333 1.58398 17.583 0.833984 16.6663 0.833984H8.32467C7.40801 0.833984 6.66634 1.58398 6.66634 2.50065H14.9997C15.9163 2.50065 16.6663 3.25065 16.6663 4.16732V15.0007ZM13.333 4.16732H4.99967C4.08301 4.16732 3.33301 4.91732 3.33301 5.83398V19.1673L9.16634 16.6673L14.9997 19.1673V5.83398C14.9997 4.91732 14.2497 4.16732 13.333 4.16732Z" fill="#826748"/>
  </Icon>
);
